class LatestPostsBlock {
	static CLASS_NAME_BTN = 'btn'
	static CLASS_NAME_BTN_DEFAULT = 'btn__default'
	static CLASS_NAME_LATESTPOSTSBLOCK_ITEM = 'jtf__latestpostsblock--item'
	static CLASS_NAME_LATESTPOSTSBLOCK_TAX_LINK = 'jtf__latestpostsblock--tax-link'
	static CLASS_NAME_LATESTPOSTSBLOCK_ITEM_ACTIVE = 'jtf__latestpostsblock--item-active'
	static CLASS_NAME_LATESTPOSTSBLOCK_ITEM_FILTERED = 'jtf__latestpostsblock--item-filtered'
	static CLASS_NAME_LATESTPOSTSBLOCK_FILTER_ACTIVE = 'jtf__latestpostsblock--filter-active'
	static CLASS_NAME_LATESTPOSTSBLOCK_IMG_CONTAINER = 'jtf__latestpostsblock--img-container'
	static CLASS_NAME_LATESTPOSTSBLOCK_IMG = 'jtf__latestpostsblock--img'
	static CLASS_NAME_LATESTPOSTSBLOCK_TAX = 'jtf__latestpostsblock--tax'
	static CLASS_NAME_LATESTPOSTSBLOCK_TITLESECTION = 'jtf__latestpostsblock--titlesection'
	static CLASS_NAME_LATESTPOSTSBLOCK_TITLE = 'jtf__latestpostsblock--title'
	static CLASS_NAME_LATESTPOSTSBLOCK_TIMER = 'jtf__latestpostsblock--timer'
	static CLASS_NAME_LATESTPOSTSBLOCK_TIMER_TIME = 'jtf__latestpostsblock--timer-time'
	static CLASS_NAME_LATESTPOSTSBLOCK_TIMER_MIN = 'jtf__latestpostsblock--timer-min'
	static CLASS_NAME_LATESTPOSTSBLOCK_DATE_DATE1 = 'jtf__latestpostsblock--date-date1'
	static CLASS_NAME_LATESTPOSTSBLOCK_DATE_DATE2 = 'jtf__latestpostsblock--date-date2'
	static CLASS_NAME_LATESTPOSTSBLOCK_DATE = 'jtf__latestpostsblock--date'
	static CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR = 'jtf__latestpostsblock--author'
	static CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_DATA = 'jtf__latestpostsblock--author-data'
	static CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_NAME = 'jtf__latestpostsblock--author-name'
	static CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_PROFILE = 'jtf__latestpostsblock--author-profile'
	static CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_JOBTITLE = 'jtf__latestpostsblock--author-jobtitle'
	static CLASS_NAME_LATESTPOSTSBLOCK_COPY = 'jtf__latestpostsblock--copy'
	static CLASS_NAME_LATESTPOSTSBLOCK_READMORE = 'jtf__latestpostsblock--readmore'
	static CLASS_NAME_LATESTPOSTSBLOCK_TAGS = 'jtf__latestpostsblock--tags'
	static CLASS_NAME_LATESTPOSTSBLOCK_TAG = 'jtf__latestpostsblock--tag'
	static CLASS_NAME_ICON_CLOCK = 'fa-regular fa-clock-desk'
	static CLASS_NAME_COL_12 = 'col-12'
	static CLASS_NAME_COL_MD_3 = 'col-md-3'
	static CLASS_NAME_COL_MD_4 = 'col-md-4'
	static CLASS_NAME_COL_MD_6 = 'col-md-6'

	static SELECTOR_CLASS_BLOCK = '.jtf__block'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK = '.jtf__latestpostsblock'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_ITEM = '.jtf__latestpostsblock--item'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_TAX_LINK = '.jtf__latestpostsblock--tax-link'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_PRELOADER = '.jtf__latestpostsblock--preloader'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_LOADMORE_TRIGGER = '.jtf__latestpostsblock--loadmore-trigger'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_TAXONOMYTOGGLE_CONTAINER = '.jtf__latestpostsblock--taxonomytoggle-container'
	static SELECTOR_CLASS_LATESTPOSTSBLOCK_TAX_SELECT = '.jtf__latestpostsblock--tax-select'
	static SELECTOR_ID_TAX_SELECT = '#jtf__latestpostsblock--tax-select'
	static SELECTOR_CLASS_CONTAINER = '.container'

	static ATTR_DATA_TEXTLIMIT = 'data-textlimit'
	static ATTR_DATA_TEXTLIMITTYPE = 'data-textlimittype'
	static ATTR_DATA_TARGET = 'data-target'
	static ATTR_DATA_PARENT = 'data-parent'
	static ATTR_DATA_TERM = 'data-term'
	static ATTR_DATA_TAXONOMIES = 'data-taxonomies'
	static ATTR_DATA_TYPE = 'data-type'
	static ATTR_DATA_READMORE = 'data-readmore'
	static ATTR_DATA_AUTHOR = 'data-author'
	static ATTR_DATA_EXCERPT = 'data-excerpt'
	static ATTR_DATA_THEME = 'data-theme'
	static ATTR_DATA_DATE = 'data-date'
	static ATTR_DATA_TAXFILTER = 'data-taxfilter'
	static ATTR_DATA_TERMVISIBILITY = 'data-termvisibility'
	static ATTR_DATA_TERM_ATTR = 'data-term'
	static ATTR_DATA_CATEGORY = 'data-category'
	static ATTR_DATA_AUTHORSETTINGS = 'data-authorsettings'
	static ATTR_DATA_RANDOM = 'data-random'
	static ATTR_DATA_ACCENT = 'data-accent'
	static ATTR_DATA_TIMER = 'data-timer'
	static ATTR_DATA_COUNT = 'data-count'
	static ATTR_DATA_COLS = 'data-cols'
	static ATTR_DATA_AUTHFILTTYPE = 'data-authfilttype'
	static ATTR_DATA_AUTHFILTVAL = 'data-authfiltval'
	static ATTR_DATA_HEADINGLEVEL = 'data-headinglevel'
	static ATTR_HREF = 'href'
	static ATTR_SRC = 'src'
	static ATTR_LOADING = 'loading'
	static ATTR_STYLE = 'style'
	static ATTR_TITLE = 'title'
	static ATTR_CLASS = 'class'
	static ATTR_VALUE = 'value'
	static ATTR_ID = 'id'

	static PROP_TRUE = 'true'
	static PROP_FALSE = 'false'
	static PROP_ALL = 'all'
	static PROP_LAZY = 'lazy'
	static PROP_STATUS_OK = 200

	constructor( context ) {
		this.context = context
		this.offset = 0
		this.taxTerms = []
		this.taxToggleContainer = []

		const blockElement = context.querySelector( LatestPostsBlock.SELECTOR_CLASS_BLOCK )
		this.textLimit = blockElement ? blockElement.getAttribute( LatestPostsBlock.ATTR_DATA_TEXTLIMIT ) : null
		this.textLimitType = blockElement ? blockElement.getAttribute( LatestPostsBlock.ATTR_DATA_TEXTLIMITTYPE ) : null

		const allTermsButton = this.createElement( 'button', {
			[ LatestPostsBlock.ATTR_CLASS ]: `${ LatestPostsBlock.CLASS_NAME_BTN } ${ LatestPostsBlock.CLASS_NAME_BTN_DEFAULT } ${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX_LINK }`,
			[ LatestPostsBlock.ATTR_HREF ]: '#',
			[ LatestPostsBlock.ATTR_TITLE ]: 'All',
			[ LatestPostsBlock.ATTR_DATA_TARGET ]: LatestPostsBlock.PROP_ALL,
		}, 'All' )

		this.taxToggleContainer.push( allTermsButton )
		this.init()
	}

	static dateSuffix( d ) {
		// noinspection MagicNumberJS
		if ( d > 3 && d < 21 ) {
			return 'th'
		}
		switch ( d % 10 ) {
			case 1: {
				return 'st'
			}
			case 2: {
				return 'nd'
			}
			case 3: {
				return 'rd'
			}
			default: {
				return 'th'
			}
		}
	}

	createElement( tag, attributes = {}, textContent = '' ) {
		const element = document.createElement( tag )
		for ( const [ key, value ] of Object.entries( attributes ) ) {
			element.setAttribute( key, value )
		}
		if ( textContent ) {
			element.textContent = textContent
		}
		return element
	}

	getPosts( postType, perPage, colCount, container, offset, thisReadMoreLink, thisAuthor, thisAuthorsetting, thisTheme, thisExcerpt, thisDate, thisTaxFilter, thisCategory, thisTermVisiblity, thisTerm, thisRandomisation, thisRandomId, thisAccent, thisTimer, thisAuthFiltType, thisAuthFiltVal, thisHeadingLevel ) {
		const url = `/wp-json/jtf/v1/post/latest?per_page=${ perPage }&offset=${ offset }&posttype=${ postType }&tax=${ thisCategory }&term=${ thisTerm }&random=${ thisRandomisation }&authortype=${ thisAuthFiltType }&authorvalue=${ thisAuthFiltVal }`

		const preloader = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_PRELOADER )
		if ( preloader ) {
			preloader.style.display = 'block'
		}

		const xhr = new XMLHttpRequest()
		xhr.open( 'GET', url )
		xhr.setRequestHeader( 'Content-Type', 'application/json' )
		// noinspection FunctionWithMultipleLoopsJS,FunctionWithMoreThanThreeNegationsJS
		xhr.onload = () => {
			if ( xhr.status === LatestPostsBlock.PROP_STATUS_OK ) {
				const json = JSON.parse( xhr.responseText )

				if ( preloader ) {
					preloader.style.display = 'none'
				}

				if ( json.length === 0 ) {
					const containerParent = container.closest( LatestPostsBlock.SELECTOR_CLASS_CONTAINER )
					if ( containerParent ) {
						const loadMoreTrigger = containerParent.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_LOADMORE_TRIGGER )
						if ( loadMoreTrigger ) {
							const contextLoadMore = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_LOADMORE_TRIGGER )
							if ( contextLoadMore ) {
								contextLoadMore.disabled = true
							}
						}
					}
				}

				if ( thisTaxFilter !== LatestPostsBlock.PROP_FALSE ) {
					for ( let z = 0; z < json.length; z++ ) {
						if ( json[ z ].taxonomies[ thisTaxFilter ] ) {
							const allTerms = json[ z ].taxonomies[ thisTaxFilter ]
							for ( let a = 0; a < allTerms.length; a++ ) {
								const termName = allTerms[ a ].name
								if ( !this.taxTerms.includes( termName ) ) {
									this.taxTerms.push( termName )
									const thisTermEl = this.createElement( 'button', {
										[ LatestPostsBlock.ATTR_CLASS ]: `${ LatestPostsBlock.CLASS_NAME_BTN } ${ LatestPostsBlock.CLASS_NAME_BTN_DEFAULT } ${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX_LINK }`,
										[ LatestPostsBlock.ATTR_HREF ]: '#',
										[ LatestPostsBlock.ATTR_DATA_TARGET ]: allTerms[ a ].slug,
									}, termName )
									this.taxToggleContainer.push( thisTermEl )
								}
							}
						}
					}

					if ( thisTheme === 'corporate' ) {
						for ( let y = 0; y < json.length; y++ ) {
							const thisPostsTaxonomies = json[ y ].taxonomies.category

							for ( let t = 0; t < thisPostsTaxonomies.length; t++ ) {
								const termName = thisPostsTaxonomies[ t ].name
								const termSlug = thisPostsTaxonomies[ t ].slug
								let slugExists = false

								const taxSelectOptions = document.querySelectorAll( `${ LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_TAX_SELECT } option` )
								for ( const option of taxSelectOptions ) {
									if ( option.getAttribute( LatestPostsBlock.ATTR_VALUE ) === termSlug ) {
										slugExists = true
										break
									}
								}

								if ( !slugExists ) {
									const newOption = this.createElement( 'option', {
										[ LatestPostsBlock.ATTR_VALUE ]: termSlug,
									}, termName )

									const taxSelect = document.querySelector( LatestPostsBlock.SELECTOR_ID_TAX_SELECT )
									if ( taxSelect ) {
										taxSelect.appendChild( newOption )
									}
								}
							}
						}
					} else {
						// Only add new filter buttons if not already present, and do not clear the container
						const taxToggleContainer = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_TAXONOMYTOGGLE_CONTAINER )
						if ( taxToggleContainer ) {
							for ( const element of this.taxToggleContainer ) {
								// Only append if not already in the DOM
								if ( ![ ...taxToggleContainer.children ].some( btn => btn.textContent === element.textContent ) ) {
									taxToggleContainer.appendChild( element )
								}
							}
						}
					}
				}

				let colClass
				switch ( colCount ) {
					case '4': {
						colClass = `${ LatestPostsBlock.CLASS_NAME_COL_12 } ${ LatestPostsBlock.CLASS_NAME_COL_MD_3 }`
						break
					}
					case '3': {
						colClass = `${ LatestPostsBlock.CLASS_NAME_COL_12 } ${ LatestPostsBlock.CLASS_NAME_COL_MD_4 }`
						break
					}
					case '2': {
						colClass = `${ LatestPostsBlock.CLASS_NAME_COL_12 } ${ LatestPostsBlock.CLASS_NAME_COL_MD_6 }`
						break
					}
					case '1': {
						colClass = LatestPostsBlock.CLASS_NAME_COL_12
						break
					}
					default: {
						colClass = `${ LatestPostsBlock.CLASS_NAME_COL_12 } ${ LatestPostsBlock.CLASS_NAME_COL_MD_4 }`
					}
				}

				for ( let x = 0; x < json.length; x++ ) {
					let termsList = ''
					if ( thisTaxFilter !== LatestPostsBlock.PROP_FALSE ) {
						for ( let y = 0; y < json[ x ].taxonomies[ thisTaxFilter ].length; y++ ) {
							const thisTerm = json[ x ].taxonomies[ thisTaxFilter ][ y ].slug
							if ( y === json[ x ].taxonomies[ thisTaxFilter ].length - 1 ) {
								termsList += thisTerm
							} else {
								termsList += thisTerm + ','
							}
						}
					}

					const itemContainer = this.createElement( 'div', {
						[ LatestPostsBlock.ATTR_CLASS ]: `${ colClass } ${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM }`,
						[ LatestPostsBlock.ATTR_DATA_PARENT ]: thisRandomId,
						[ LatestPostsBlock.ATTR_DATA_TERM ]: termsList,
					} )

					const imgContainer = this.createElement( 'div', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_IMG_CONTAINER,
					} )

					const itemLink = this.createElement( 'a', {
						[ LatestPostsBlock.ATTR_HREF ]: json[ x ].permalink,
					} )

					const itemImg = this.createElement( 'img', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_IMG,
						[ LatestPostsBlock.ATTR_LOADING ]: LatestPostsBlock.PROP_LAZY,
					} )

					if ( thisTermVisiblity === '1' ) {
						const taxContainer = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX,
						} )

						if ( thisCategory === LatestPostsBlock.PROP_TRUE && thisTaxFilter !== LatestPostsBlock.PROP_FALSE ) {
							itemContainer.setAttribute( LatestPostsBlock.ATTR_DATA_TAXONOMIES, json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name )
							taxContainer.textContent = json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name
						} else if ( thisCategory === LatestPostsBlock.PROP_TRUE && thisTaxFilter === LatestPostsBlock.PROP_FALSE ) {
							for ( const taxonomy in json[ x ].taxonomies ) {
								if ( json[ x ].taxonomies[ taxonomy ] ) {
									itemContainer.setAttribute( LatestPostsBlock.ATTR_DATA_TAXONOMIES, json[ x ].taxonomies[ taxonomy ][ 0 ].name )
									taxContainer.textContent = json[ x ].taxonomies[ taxonomy ][ 0 ].name
								}
								break
							}
						} else {
							if ( thisTaxFilter !== LatestPostsBlock.PROP_FALSE ) {
								if ( json[ x ].taxonomies[ thisTaxFilter ] ) {
									let taxTerms = ''
									for ( let t = 0; t < json[ x ].taxonomies[ thisTaxFilter ].length; t++ ) {
										if ( t === json[ x ].taxonomies[ thisTaxFilter ].length - 1 ) {
											taxTerms += json[ x ].taxonomies[ thisTaxFilter ][ t ].slug
										} else {
											taxTerms += json[ x ].taxonomies[ thisTaxFilter ][ t ].slug + ','
										}
									}
									itemContainer.setAttribute( LatestPostsBlock.ATTR_DATA_TAXONOMIES, taxTerms )
									taxContainer.textContent = json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name
								}
							} else {
								let taxTerms = ''
								for ( let t = 0; t < json[ x ].taxonomies[ thisCategory ].length; t++ ) {
									if ( t === json[ x ].taxonomies[ thisCategory ].length - 1 ) {
										taxTerms += json[ x ].taxonomies[ thisCategory ][ t ].slug
									} else {
										taxTerms += json[ x ].taxonomies[ thisCategory ][ t ].slug + ','
									}
								}
								itemContainer.setAttribute( LatestPostsBlock.ATTR_DATA_TAXONOMIES, taxTerms )
								taxContainer.textContent = json[ x ].taxonomies[ thisCategory ][ 0 ].name
							}
						}

						if ( thisTheme !== 'alt4' ) {
							itemContainer.appendChild( taxContainer )
						}

						if ( thisTheme === 'corporate' ) {
							imgContainer.appendChild( taxContainer )
						}
					}

					const postMeta = json[ x ].post_meta
					const altImage = postMeta._mediabang_altimg
					let imageSrc

					if ( altImage && altImage !== '[]' ) {
						const altImageData = JSON.parse( altImage )
						imageSrc = altImageData?.url || postMeta?._mediabang_altimg_preview
					} else {
						imageSrc = postMeta._header_image?.attachment?.large?.[ 0 ] ||
							'https://covers.tandf.co.uk/covers/TANF_MR.jpg'
					}

					if ( imageSrc ) {
						itemImg.setAttribute( LatestPostsBlock.ATTR_SRC, imageSrc )
					}

					const titleSection = this.createElement( 'div', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TITLESECTION,
						[ LatestPostsBlock.ATTR_STYLE ]: `--accent:${ thisAccent }`,
					} )

					const itemTitle = this.createElement( thisHeadingLevel, {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TITLE,
					} )

					const itemTimer = this.createElement( 'div', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TIMER,
						[ LatestPostsBlock.ATTR_STYLE ]: `--accent:${ thisAccent }`,
					} )

					const itemTimes = this.createElement( 'div' )

					const itemTime = this.createElement( 'span', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TIMER_TIME,
						[ LatestPostsBlock.ATTR_STYLE ]: `--accent:${ thisAccent }`,
					} )

					const itemMin = this.createElement( 'span', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TIMER_MIN,
						[ LatestPostsBlock.ATTR_STYLE ]: `--accent:${ thisAccent }`,
					}, ' min' )

					const itemClock = this.createElement( 'i', {
						[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_ICON_CLOCK,
						[ LatestPostsBlock.ATTR_STYLE ]: `--accent:${ thisAccent }`,
					} )

					const itemTitleInner = this.createElement( 'a', {
						[ LatestPostsBlock.ATTR_HREF ]: json[ x ].permalink,
					} )

					if ( thisTimer ) {
						this.getPostReadtime( json[ x ].ID, itemTime )
						itemTimes.appendChild( itemTime )
						itemTimes.appendChild( itemMin )
						itemTimer.appendChild( itemTimes )
						itemTimer.appendChild( itemClock )
					}

					switch ( thisTheme ) {
						case 'alt2': {
							itemTitleInner.textContent = json[ x ].post_title
							itemTitle.appendChild( itemTitleInner )
							titleSection.appendChild( itemTitle )
							if ( thisTimer ) {
								titleSection.appendChild( itemTimer )
							}
							itemContainer.appendChild( titleSection )
							itemLink.appendChild( itemImg )
							imgContainer.appendChild( itemLink )
							itemContainer.appendChild( imgContainer )
							break
						}
						case 'alt4': {
							itemLink.appendChild( itemImg )
							imgContainer.appendChild( itemLink )
							itemContainer.appendChild( imgContainer )
							itemTitleInner.textContent = json[ x ].post_title
							itemTitle.appendChild( itemTitleInner )
							titleSection.appendChild( itemTitle )
							if ( thisTimer ) {
								titleSection.appendChild( itemTimer )
							}
							itemContainer.appendChild( titleSection )
							break
						}
						default: {
							itemLink.appendChild( itemImg )
							imgContainer.appendChild( itemLink )
							itemContainer.appendChild( imgContainer )
							itemTitleInner.textContent = json[ x ].post_title
							itemTitle.appendChild( itemTitleInner )
							titleSection.appendChild( itemTitle )
							if ( thisTimer ) {
								titleSection.appendChild( itemTimer )
							}
							itemContainer.appendChild( titleSection )
						}
					}

					const postPublishDate = json[ x ].post_date
					const dateAsObj = new Date( postPublishDate )
					const date = new Date( dateAsObj )
					const day = date.getDate()
					const months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ]
					const month = months[ date.getMonth() ]
					const year = date.getFullYear()

					switch ( thisDate ) {
						case LatestPostsBlock.PROP_TRUE: {
							const itemDateheader = this.createElement( 'span', {
								[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_DATE_DATE1,
							}, `${ day }${ LatestPostsBlock.dateSuffix( day ) } ${ month } ${ year }` )

							itemContainer.appendChild( itemDateheader )
							break
						}
						case 'besideTitle': {
							const itemDatebesidesTitle = this.createElement( 'span', {
								[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_DATE_DATE2,
							}, `${ day }${ LatestPostsBlock.dateSuffix( day ) } ${ month } ${ year }` )

							itemContainer.appendChild( itemDatebesidesTitle )
							break
						}
						case 'bottom': {
							const itemDatebottom = this.createElement( 'span', {
								[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_DATE,
							}, `${ day }${ LatestPostsBlock.dateSuffix( day ) } ${ month } ${ year }` )

							itemContainer.appendChild( itemDatebottom )
							break
						}
						case LatestPostsBlock.PROP_FALSE:
						default: {
							break
						}
					}

					if ( thisTheme === 'corporate' ) {
						const itemDateTop = this.createElement( 'span', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_DATE,
						}, `${ day }${ LatestPostsBlock.dateSuffix( day ) } ${ month } ${ year }` )

						const tagContainer = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAGS,
						} )

						const tags = json[ x ].taxonomies.post_tag

						for ( let tagIndex = 0; tagIndex < tags.length; tagIndex++ ) {
							const tempTag = this.createElement( 'span', {
								[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAG,
							}, tags[ tagIndex ].name )

							tagContainer.appendChild( tempTag )
						}

						itemLink.appendChild( itemImg )
						imgContainer.appendChild( itemLink )
						itemContainer.appendChild( imgContainer )
						itemTitleInner.textContent = json[ x ].post_title
						itemTitle.appendChild( itemTitleInner )
						titleSection.appendChild( itemDateTop )
						titleSection.appendChild( itemTitle )
						titleSection.appendChild( tagContainer )
					}

					if ( thisTheme === 'alt4' ) {
						const hr = document.createElement( 'hr' )
						itemContainer.appendChild( hr )
						const taxContainer = itemContainer.querySelector( `.${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX }` )
						if ( taxContainer ) {
							itemContainer.appendChild( taxContainer )
						}
					}

					if ( thisAuthor === LatestPostsBlock.PROP_TRUE ) {
						const itemAuthor = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR,
						} )

						const itemAuthorData = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_DATA,
						} )

						const itemAuthorName = this.createElement( 'span', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_NAME,
						} )

						let joinedName = `${ json[ x ].author_data.first_name } ${ json[ x ].author_data.last_name }`

						if ( !json[ x ].author_data.first_name ) {
							joinedName = 'Anon'
						}
						itemAuthorName.textContent = joinedName
						itemAuthorData.appendChild( itemAuthorName )

						const itemAuthorProfile = this.createElement( 'img', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_PROFILE,
							[ LatestPostsBlock.ATTR_SRC ]: json[ x ].author_data.avatar,
							[ LatestPostsBlock.ATTR_DATA_TYPE ]: thisAuthorsetting,
						} )

						itemAuthorData.appendChild( itemAuthorProfile )

						const itemAuthorjobtitle = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_AUTHOR_JOBTITLE,
						}, json[ x ].author_data.job_title )

						itemAuthorData.appendChild( itemAuthorjobtitle )
						itemAuthor.appendChild( itemAuthorData )
						itemContainer.appendChild( itemAuthor )
					}

					if ( thisExcerpt === LatestPostsBlock.PROP_TRUE ) {
						const itemCopy = this.createElement( 'div', {
							[ LatestPostsBlock.ATTR_CLASS ]: LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_COPY,
						} )

						const itemCopyContainer = this.createElement( 'p' )
						let trimmedString = ''

						const string = this.stripHtml( json[ x ].excerpt ? json[ x ].excerpt : json[ x ].post_content )

						if ( this.textLimitType === 'wordlim' ) {
							const copy = string.split( ' ' )
							let renderString = ''
							for ( let wordIndex = 0; wordIndex < this.textLimit; wordIndex++ ) {
								if ( typeof copy[ wordIndex ] !== 'undefined' ) {
									renderString += (wordIndex > 0 ? ' ' : '') + copy[ wordIndex ]
								}
							}
							trimmedString = renderString
						} else {
							trimmedString = string.substring( 0, this.textLimit )
						}

						if ( trimmedString && trimmedString.length < string.length ) {
							itemCopyContainer.textContent = trimmedString + ' ...'
						} else {
							itemCopyContainer.textContent = trimmedString
						}
						itemCopy.appendChild( itemCopyContainer )

						if ( thisTheme === 'corporate' ) {
							titleSection.appendChild( itemCopy )
							itemContainer.appendChild( titleSection )
						} else {
							itemContainer.appendChild( itemCopy )
						}
					}

					const readMoreLink = this.createElement( 'a', {
						[ LatestPostsBlock.ATTR_CLASS ]: `${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_READMORE } ${ LatestPostsBlock.CLASS_NAME_BTN } ${ LatestPostsBlock.CLASS_NAME_BTN_DEFAULT }`,
						[ LatestPostsBlock.ATTR_HREF ]: json[ x ].permalink,
					}, 'Read more' )

					if ( thisReadMoreLink === '1' ) {
						itemContainer.appendChild( readMoreLink )
					}
					container.appendChild( itemContainer )
					this.filterPosts( LatestPostsBlock.PROP_ALL, thisRandomId )
				}
			}
		}
		xhr.send()
	}

	getPostReadtime( id, element ) {
		const xhr = new XMLHttpRequest()
		const url = `/wp-json/jtf/v1/string/readtime?id=${ id }`
		xhr.open( 'GET', url )
		xhr.onload = ( response ) => {
			if ( xhr.status === 200 ) {
				const json = JSON.parse( response.currentTarget.response )
				element.textContent = json
			}
		}
		xhr.send()
	}

	stripHtml( html ) {
		const tmp = document.createElement( 'DIV' )
		tmp.innerHTML = html
		return tmp.textContent || tmp.innerText || ''
	}

	generateRandomString( length ) {
		let result = ''
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
		const charactersLength = characters.length
		for ( let i = 0; i < length; i++ ) {
			result += characters.charAt( Math.floor( Math.random() * charactersLength ) )
		}
		return result
	}

	// noinspection FunctionWithMultipleLoopsJS
	filterPosts( thisTarget ) {
		const active = []
		if ( active.includes( thisTarget ) ) {
			for ( let i = 0; i < active.length; i++ ) {
				if ( active[ i ] === thisTarget ) {
					active.splice( i, 1 )
				}
			}
		} else {
			active.push( thisTarget )
		}

		for ( let a = 0; a < active.length; a++ ) {
			const items = this.context.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_ITEM )
			for ( const item of items ) {
				item.style.display = 'none'
				const termAttr = item.getAttribute( LatestPostsBlock.ATTR_DATA_TERM )
				if ( termAttr ) {
					const taxArr = termAttr.split( ',' )
					for ( let y = 0; y < taxArr.length; y++ ) {
						if ( active[ a ] === taxArr[ y ] || LatestPostsBlock.PROP_ALL === active[ a ] ) {
							item.style.display = 'block'
						}
					}
				} else {
					item.style.display = 'block'
				}
			}
		}
	}


	// noinspection FunctionWithMultipleLoopsJS
	init() {
		// noinspection FunctionWithMultipleLoopsJS
		this.context.addEventListener( 'click', ( e ) => {
			const target = e.target
			if ( target.classList.contains( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX_LINK ) ) {
				e.preventDefault()
				const thisParentId = target.getAttribute( LatestPostsBlock.ATTR_DATA_PARENT )
				const thisParent = document.getElementById( thisParentId )
				const thisTarget = target.getAttribute( LatestPostsBlock.ATTR_DATA_TARGET )
				const blockContext = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK )

				if ( blockContext ) {
					const taxLinks = blockContext.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_TAX_LINK )
					for ( const link of taxLinks ) {
						if ( link !== target ) {
							link.classList.remove( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM_ACTIVE )
						}
					}
				}

				target.classList.add( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM_ACTIVE )

				if ( thisParent ) {
					const items = thisParent.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_ITEM )
					for ( const item of items ) {
						item.classList.remove( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM_FILTERED )
					}

					const activeItems = thisParent.querySelectorAll( `.${ LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM_ACTIVE }` )
					if ( activeItems.length > 0 ) {
						thisParent.classList.add( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_FILTER_ACTIVE )
					} else {
						thisParent.classList.remove( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_FILTER_ACTIVE )
					}
				}

				this.filterPosts( thisTarget )
			}
		} )

		this.context.addEventListener( 'change', ( e ) => {
			const target = e.target
			if ( target.classList.contains( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_TAX_SELECT.substring( 1 ) ) ) {
				e.preventDefault()
				const thisTarget = target.value
				const blockContext = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK )

				if ( blockContext ) {
					const items = blockContext.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_ITEM )
					for ( const item of items ) {
						item.classList.remove( LatestPostsBlock.CLASS_NAME_LATESTPOSTSBLOCK_ITEM_FILTERED )
					}
				}

				this.filterPosts( thisTarget )
			}
		} )

		const blockContext = this.context.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK )
		const containerTarget = blockContext
		const thisReadMoreLink = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_READMORE )
		const thisAuthor = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_AUTHOR )
		const thisExcerpt = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_EXCERPT )
		const thisTheme = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_THEME )
		const thisDate = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_DATE )
		const thisTaxFilter = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_TAXFILTER )
		const thisTermVisiblity = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_TERMVISIBILITY )
		const thisTerm = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_TERM_ATTR )
		const thisCategory = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_CATEGORY )
		const thisAuthorsetting = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_AUTHORSETTINGS )
		const thisRandomisation = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_RANDOM )
		const thisAccent = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_ACCENT )
		const thisTimer = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_TIMER )
		const thisRandomId = `jtf__latestpostsblock--parent-${ this.generateRandomString( 5 ) }`

		blockContext.setAttribute( LatestPostsBlock.ATTR_ID, thisRandomId )

		const taxLinks = blockContext.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_TAX_LINK )
		for ( const taxLink of taxLinks ) {
			blockContext.setAttribute( LatestPostsBlock.ATTR_DATA_PARENT, thisRandomId )
			this.taxTerms.push( taxLink.textContent )
		}

		const items = blockContext.querySelectorAll( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_ITEM )
		for ( const item of items ) {
			item.setAttribute( LatestPostsBlock.ATTR_DATA_PARENT, thisRandomId )
		}

		const loadMoreTrigger = blockContext.parentElement.querySelector( LatestPostsBlock.SELECTOR_CLASS_LATESTPOSTSBLOCK_LOADMORE_TRIGGER )
		if ( loadMoreTrigger ) {
			loadMoreTrigger.addEventListener( 'click', ( e ) => {
				const thisPostType = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_TYPE )
				const thisPostCount = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_COUNT )
				const thisColCount = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_COLS )
				const thisAuthFiltType = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_AUTHFILTTYPE )
				const thisAuthFiltVal = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_AUTHFILTVAL )
				const thisHeadingLevel = blockContext.getAttribute( LatestPostsBlock.ATTR_DATA_HEADINGLEVEL )
				const offset = parseInt( this.offset ) + parseInt( thisPostCount )

				if ( thisPostType ) {
					e.preventDefault()
				}
				this.offset = offset

				this.getPosts(
					thisPostType,
					thisPostCount,
					thisColCount,
					containerTarget,
					offset,
					thisReadMoreLink,
					thisAuthor,
					thisAuthorsetting,
					thisTheme,
					thisExcerpt,
					thisDate,
					thisTaxFilter,
					thisCategory,
					thisTermVisiblity,
					thisTerm,
					thisRandomisation,
					thisRandomId,
					thisAccent,
					thisTimer,
					thisAuthFiltType,
					thisAuthFiltVal,
					thisHeadingLevel,
				)
			} )
		}
	}
}

export default function init() {
	const blocks = document.querySelectorAll( '.wp-block-jtf-jtf-latestpost' )
	if ( blocks.length > 0 ) {
		for ( const block of blocks ) {
			new LatestPostsBlock( block )
		}
	}
}